import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";

const HowWorks = () => {
    return (
        <>
            <Screen paddingTopTitle={true} title="Como os anúncios funcionam">
                <Helmet>
                        <title>Paçoca - Como os anúncios funcionam</title>
                        <meta name="description" content={`Saiba como funciona anúncios e propagandas no Paçoca!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Anúncios, propaganda, marketing}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - como os anuncios funcionam`}/>
                        <meta property="og:description" content={`Saiba como funciona anúncios e propagandas no Paçoca!`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - como os anuncios funcionam`}/>
                        <meta name="twitter:description" content={`Saiba como funciona anúncios e propagandas no Paçoca!`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <div className="padding-big-screen">
                        <div style={{textAlign: "justify"}}>
                                <p>
                                        No Paçoca, os anúncios são cobrados com base na quantidade de visualizações. Ao criar seu anúncio, você define o número máximo de visualizações desejadas — e só paga por isso. Assim que esse limite for atingido, o anúncio deixa de ser exibido automaticamente.
                                </p>

                                <p>
                                        Antes de ir ao ar, todo anúncio passa por uma análise automática feita por nossa inteligência artificial, que verifica se o conteúdo está de acordo com nossas políticas e diretrizes. Isso garante mais segurança e qualidade para os usuários da plataforma.
                                </p>

                                <p>
                                        O pagamento é realizado antes da análise. Caso o anúncio seja reprovado, ele não será publicado e <strong>não haverá reembolso automático</strong>. Ao criar o anúncio, o anunciante deve aceitar esse termo de forma clara.
                                </p>

                                <p>
                                        Se você considerar que a reprovação foi injusta, é possível solicitar uma reavaliação ou reembolso manual entrando em contato com nossa equipe através do Discord.
                                </p>

                                <p>
                                        Após a aprovação da IA, o anúncio é publicado automaticamente na plataforma.
                                </p>

                                <div style={{marginTop: "20px"}}>
                                        <p>Os anúncios no Paçoca passam por diferentes etapas:</p>
                                        <ul style={{lineHeight: "1.6"}}>
                                                <li><strong>✔ Ativo</strong>: O anúncio está publicado e visível.</li>
                                                <li><strong>🔎 Validando conteúdo</strong>: Aguardando aprovação da nossa IA.</li>
                                                <li><strong>💰 Pagamento pendente</strong>: O pagamento ainda não foi identificado.</li>
                                                <li><strong>📢 Online</strong>: O anúncio foi aprovado e está rodando.</li>
                                                <li><strong>⛔ Atingiu o esperado</strong>: O limite de visualizações foi atingido e o anúncio parou.</li>
                                        </ul>
                                </div>

                        </div>
                </div>
            </Screen>
        </>
    );
};

export default HowWorks;